import React from "react";
import { FaArrowRight, FaInfoCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const ConnectMessage = () => {
  const location = useLocation();
  const { isNewCitoyen, isNewTuteur } = location.state || {};

  return (
    <div
      className="center-container p-4"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "80vh",
      }}
    >

      <form className="mb-4 justify-content-center">
        {/* {isNewCitoyen  ? (<p> New Citoyen</p> ) : (<p> old Citoyen</p>)}
                    {isNewTuteur ? (<p> New Tuteur</p> ) : (<p> old tuteur</p>)} */}
        {isNewCitoyen || isNewTuteur ? (
          <div className="connectMessage-card">
            <div className="card-body p-5">
              <aside className="MuiCallout-root MuiCallout-success p-3">
                <FaInfoCircle
                  style={{
                    alignSelf: "center",
                    marginRight: "1%",
                  }}
                />
                <div className="MuiCallout-content">
                  <p style={{ color: "rgb(22 101 52 / 1)" }}>
                    Votre demande a bien été envoyée
                  </p>
                </div>
              </aside>
              <h6 className="d-flex p-2">
                <FaInfoCircle
                  style={{
                    alignSelf: "center",
                    marginRight: "1%",
                  }}
                />
                Étape Importante
              </h6>
              <p className="text-start p-2">
                Pour activer votre compte et{" "}
                <span className="fw-bold color-base ms-1 me-1">
                  {" "}
                  Suivre l'état de votre Déclaration
                </span>
                <br />
                veuillez passer à l'étape suivante en choisissant un mot de
                passe
              </p>
              <div className="d-flex justify-content-end mt-4">
                <Link to="/login" className="btn btn-black">
                  Continuer <FaArrowRight />
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="connectMessage-card">
            <div className="card-body p-5">
              <aside className="MuiCallout-root MuiCallout-success p-3">
                <FaInfoCircle
                  style={{
                    alignSelf: "center",
                    marginRight: "1%",
                  }}
                />
                <div className="MuiCallout-content">
                  <p style={{ color: "rgb(22 101 52 / 1)" }}>
                    Votre demande a bien été envoyée
                  </p>
                </div>
              </aside>
              <h6 className="d-flex p-2">
                <FaInfoCircle
                  style={{
                    alignSelf: "center",
                    marginRight: "1%",
                  }}
                />
                Étape Importante
              </h6>
              <p className="text-start p-2">
                <span className="fw-bold color-base ms-1 me-1">
                  {" "}
                  Connectez-vous
                </span>{" "}
                pour accéder à votre compte et{" "}
                <span className="fw-bold ms-1 me-1">
                  {" "}
                  suivre vos démarches.
                  <br />
                </span>{" "}
                Si vous avez oublié votre mot de passe, utilisez le lien de
                réinitialisation.
              </p>
              <div className="d-flex justify-content-end mt-4">
                <Link to="/login" className="btn btn-black">
                  Continuer <FaArrowRight />
                </Link>
              </div>
            </div>
          </div>
        )}
        {/* <div className="connectMessage-card">
                    
                    <div className="card-body p-5">
                    <aside className="MuiCallout-root MuiCallout-success p-3">
                    <FaInfoCircle
                        style={{
                            alignSelf: "center",
                            marginRight: "1%",
                        }}
                    />
                    <div className="MuiCallout-content">
                        <p style={{ color: "rgb(22 101 52 / 1)" }}>
                            Votre demande a bien été envoyée
                        </p>
                    </div>
                </aside>
                        <h6 className="d-flex p-2">
                            <FaInfoCircle
                                style={{
                                    alignSelf: "center",
                                    marginRight: "1%",
                                }}
                            />
                            Étape Importante
                        </h6>
                        <p className="text-start p-2">
                            Pour activer votre compte et <span className='fw-bold color-base ms-1 me-1'>  Suivre l'état de votre Déclaration</span>
                            <br />
                            veuillez passer à l'étape suivante en choisissant un mot de passe
                        </p>
                        <div className='d-flex justify-content-end mt-4'>
                        <button className="btn btn-black">
                            Continuer <FaArrowRight />
                        </button>
                        </div>
                      
                    </div>
                </div> */}
      </form>
    </div>
  );
};

export default ConnectMessage;
